<template>
  <div
    class="date-search hstack gap-4"
    v-if="userStore.can('reports_edit')"
  >
    <template v-if="reportType"> Сформировать новый отчет </template>
    <template v-else> Сформировать новый акт списания ТМЦ </template>

    <SelectIdObject
      v-if="reportType === 'coordinator_po'"
      :options="forCoord"
      :autoSort="false"
      class="flex-grow-1 position-relative col-3 mb-2"
      v-model="selectedForCoord"
    />

    <div class="hstack gap-3">
      <div class="hstack gap-2">
        <span>за</span>
        <SelectIdObject
          :options="monthYears"
          :autoSort="false"
          v-model="selectedMonthYear"
          class="text-nowrap w-100"
        />
      </div>
      <span>или</span>
      <div class="hstack gap-2">
        <span>c</span>
        <DatePicker v-model="start_period" />
        <span>до</span>
        <DatePicker
          v-model="end_period"
          :maxDate="current_date"
        />
      </div>
    </div>

    <button
      type="button"
      @click.prevent="createReport"
      class="btn btn-sm btn-outline-primary"
    >
      <x-icon icon="check"/>
    </button>
  </div>
</template>

<script setup>
import SelectIdObject from '@/components/select/selectIdObject.vue'
import DatePicker from '@provise/components/datepicker.vue'
import { ref, watch } from 'vue'
import { format } from 'date-fns'
import { useUserStore } from '@provise/stores/user.js'
const userStore = useUserStore()

const emit = defineEmits(['create_report'])

defineProps({
  date: {
    type: Boolean,
    default: false,
  },
  reportType: {
    type: String,
    default: '',
  },
})

const currentDate = new Date()
const currentYear = currentDate.getFullYear()
const currentMonth = currentDate.getMonth()

const months = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
]
const forCoord = [
  { id: 0, name: 'Сформировать по дате инвойса' },
  { id: 1, name: 'Сформировать по дате РО' },
]
const selectedForCoord = ref({ id: 0, name: 'Сформировать по дате инвойса' })

const generateMonthYears = () => {
  const startYear = 2024
  const monthYears = [{ id: 'Индивидуальное значение', name: 'Индивидуальное значение' }]

  for (let year = currentYear; year >= startYear; year--) {
    const endMonth = year === currentYear ? currentMonth : 11
    const startMonth = 0

    for (let month = endMonth; month >= startMonth; month--) {
      monthYears.push({
        id: `${month}-${year}`,
        name: `${months[month]} ${year}`,
      })
    }
  }
  return monthYears
}

const monthYears = generateMonthYears()

const selectedMonthYear = ref({
  id: `${currentMonth}-${currentYear}`,
  name: `${months[currentMonth]} ${currentYear}`,
})
const start_period = ref(new Date(currentYear, currentMonth, 1))
const end_period = ref(new Date())
const current_date = ref(new Date())

const updatePeriods = () => {
  if (selectedMonthYear.value.id !== 'Индивидуальное значение') {
    const [month, year] = selectedMonthYear.value.id.split('-').map(Number)
    start_period.value = new Date(year, month, 1)
    if (current_date.value < end_period.value) {
      end_period.value = current_date.value
    } else {
      end_period.value = new Date(year, month + 1, 0)
    }
  }
}

const changePeriod = () => {
  const start = new Date(start_period.value)
  const end = new Date(end_period.value)

  if (current_date.value < end_period.value) {
    end_period.value = current_date.value
  }

  const startMonth = start.getMonth()
  const endMonth = end.getMonth()
  const startYear = start.getFullYear()
  const endYear = end.getFullYear()

  const isFullMonth =
    start.getDate() === 1
    && end.getDate() === new Date(startYear, startMonth + 1, 0).getDate()
    && startMonth === endMonth
    && startYear === endYear

  const isCurrentMonthPeriod =
    startMonth === currentMonth
    && startYear === currentYear
    && start.getDate() === 1
    && end.getDate() === currentDate.getDate()

  selectedMonthYear.value =
    isFullMonth || isCurrentMonthPeriod
      ? monthYears.find(option => option.id === `${startMonth}-${startYear}`)
      : { id: 'Индивидуальное значение', name: 'Индивидуальное значение' }
}

const createReport = () => {
  let data = {
    date_from: format(start_period.value, 'yyyy-MM-dd'),
    date_to: format(end_period.value, 'yyyy-MM-dd'),
  }
  if (selectedForCoord.value.id === 1) {
    data.options = { po_date: true }
  }
  emit('create_report', data)
}

watch(selectedMonthYear, () => {
  updatePeriods()
})

watch([start_period, end_period], () => {
  changePeriod()
})
</script>
